import React from 'react'
import { Container, DriversContent, DriversTitle } from './styles'

const MainActors = ({ mainActors, isTitleNotShown }) => {
  return (
    <Container>
      {!!mainActors && !!mainActors?.length && (
        <>
          {!isTitleNotShown && <DriversTitle>Main Actors</DriversTitle>}
          {mainActors?.map((actor, i) => {
            return <DriversContent key={i}>{actor?.name}</DriversContent>
          })}
        </>
      )}
    </Container>
  )
}

export default MainActors
